<search-testing-labs [assignedOnly]=true [showSearch]=false [showAddNew]="false"></search-testing-labs>
